import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Area} from '@core/area';
import {BroadcastService} from '@core/broadcast/broadcast.service';
import {OpenLandModalEvent} from '@events/OpenLandModalEvent';
import {RefreshEvent} from '@events/RefreshEvent';
import {AreaFilter} from "@components/areas/list/areaFilter";
import {ParkService} from "@core/park/park.service";
import {ThingService} from "@core/thing/thing.service";
import {KngActivityIndicatorService} from '@layout/kingswell/services/kngActivityIndicator.service';
import {MainKngContentScrollEvent} from "@events/MainKngContentScrollEvent";
import {Subscription} from "rxjs/Subscription";

@Component({
  selector: 'areas-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class AreasListComponent implements OnInit, OnDestroy {

  worlds = [];
  public area: Area;
  public editMode: boolean = false;

  public activeWorld;

  public filters: { [key: string]: AreaFilter; } = {};

  showStickyHeader: boolean = false;

  // subscriptions
  private refresherSubscription: Subscription;
  private mainKngContentScrollSubscription: Subscription;

  constructor(private park: ParkService, private thing: ThingService,
              private broadcast: BroadcastService, private openLandModalEvent: OpenLandModalEvent,
              private refresher: RefreshEvent, private kngActivityIndicator: KngActivityIndicatorService,
              private mainKngContentScrollEvent: MainKngContentScrollEvent) { }

  ngOnInit() {
    this.refreshData();

    this.refresherSubscription = this.refresher.on().subscribe(data => {
      if (data === 'refresh.lands') {
        this.refreshData();
      }
    });

    this.mainKngContentScrollSubscription = this.mainKngContentScrollEvent.on()
      .subscribe((topScroll) => {
        this.showStickyHeader = (topScroll > 107);
      });
  }

  ngOnDestroy(): void {
    if (this.refresherSubscription)
      this.refresherSubscription.unsubscribe();
    if (this.mainKngContentScrollSubscription)
      this.mainKngContentScrollSubscription.unsubscribe();
  }

  refreshData() {
    this.kngActivityIndicator.show();
    this.thing.reloadThingDataLazy(); // just flag to reload the thing data, but only builds the data as lazy loading
    this.park.reloadWorldsKingdomsLands().then(res => {
      this.worlds = res.worlds;
      // assigning filters:
      this.worlds.forEach((world)=>{
        this.filters[world.worldId] = new AreaFilter();
      });
      this.activeWorld = this.worlds[0];

      this.kngActivityIndicator.close();
    });
  }

  addLand($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.openLandModalEvent.fire('add', new Area());
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/areas/list/list.component.ts